import type { LightingState, Project } from '@alrimal/contracts';
import { useLocale } from '../LocaleContext.tsx';
import { Brand } from './Brand.tsx';

export interface TopBarProps {
  project: Project;
  light: LightingState;
  onLightChange(next: LightingState): void;
  canGoBack: boolean;
  onBack(): void;
}

export function TopBar({
  project,
  light,
  onLightChange,
  canGoBack,
  onBack,
}: TopBarProps) {
  const { t, locale, setLocale } = useLocale();

  return (
    <header className="topbar">
      <div className="topbar__identity">
        <Brand />
        <div className="topbar__titles">
          <p className="topbar__title">
            {project.nameAr}
            {project.demoData ? (
              <span className="demo-badge">{t('notice.demo')}</span>
            ) : null}
          </p>
          <p className="topbar__subtitle">
            {project.districtAr} · {project.cityAr} · {t('brand.marketedBy')}{' '}
            {project.marketerAr}
          </p>
        </div>
      </div>

      <div className="topbar__actions">
        {canGoBack ? (
          <button type="button" className="btn btn--ghost" onClick={onBack}>
            {t('nav.backToMasterplan')}
          </button>
        ) : null}

        <div
          className="topbar__lighting"
          role="group"
          aria-label={t('action.lighting')}
        >
          <button
            type="button"
            className="btn btn--icon"
            aria-pressed={light === 'day'}
            onClick={() => onLightChange('day')}
          >
            {t('action.day')}
          </button>
          <button
            type="button"
            className="btn btn--icon"
            aria-pressed={light === 'night'}
            onClick={() => onLightChange('night')}
          >
            {t('action.night')}
          </button>
        </div>

        <button
          type="button"
          className="btn btn--ghost"
          lang={locale === 'ar' ? 'en' : 'ar'}
          onClick={() => setLocale(locale === 'ar' ? 'en' : 'ar')}
        >
          {t('action.language')}
        </button>
      </div>
    </header>
  );
}
